// @flow

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

import { logger, tryParse } from '../../common'

import { sortMessageByCreatedAt } from '../models/Message'

export function mergeMessages (messages: Array<ChatBubbleMessage<any>>, newMessages: Array<ChatBubbleMessage<any>>): Array<ChatBubbleMessage<any>> {
  const result = [].concat(messages)

  newMessages.forEach(newMsg => {
    const isMessageExisted = messages.some(msg => msg.id === newMsg.id)
    if (!isMessageExisted) result.push(newMsg)
  })

  // $FlowFixMe
  return result.sort(sortMessageByCreatedAt)
}

export function aggregateMessages (messages: Array<ChatBubbleMessage<any>>): Array<ChatBubbleMessage<any>> {
  const aggregatedByMid = messages.reduce((acc, msg) => {
    const mid = msg.content?.mid

    if (!mid) {
      acc.push(msg)
      return acc
    }

    const msgByMid = acc?.find(msg => msg.content?.mid === mid)

    if (msgByMid) {
      const lastMessageContent = msg.content
      msgByMid.content = { ...lastMessageContent, text: msgByMid.content.text + msg.content.text }
    } else {
      if (!msg.content.text && (msg.content.quick_replies || []).length > 0) {
        const reverseIndexTarget = acc[acc.length - 1].content?.senderAction !== 'typing_off' ? 1 : 2
        acc[acc.length - reverseIndexTarget].content.quick_replies = msg.content.quick_replies
      } else {
        acc.push(msg)
      }
    }

    return acc
  }, [])

  return aggregatedByMid
}

const handleAppendMessages = (vuexStore: any, payload: any) => {
  const newMessages = tryParse(payload, [])
  if (!Array.isArray(newMessages)) return

  vuexStore.state.messages.messages.forEach(oldMessage => {
    oldMessage.lastMessage = false
    oldMessage.new = false
  })
  newMessages.forEach(newMessage => {
    newMessage.lastMessage = false
    newMessage.new = true
  })

  // const start = window.performance.now()
  const sortedMessages = mergeMessages(vuexStore.state.messages.messages, newMessages)
  // const end = window.performance.now()
  // console.log(`Execution time: ${end - start} ms`)

  const aggregatedMessages = aggregateMessages(sortedMessages)

  // $FlowFixMe
  if (aggregatedMessages.length > 0) aggregatedMessages[aggregatedMessages.length - 1].lastMessage = true

  // Dominik; 18.03.2020; sometimes we receive the same messages all over again; no need to change; have not yet
  // understood or investigated why; right now we assume checking the length is enough to check for equality
  if (aggregatedMessages.length !== vuexStore.state.messages.messages.length) {
    vuexStore.dispatch('setMessageHistory', aggregatedMessages)
  }
}

// this takes care of ONE websocket message, which consists of MANY chat messages
export const onMessage = (vuexStore: any): any => (event: any) => {
  const data = tryParse(event.data)

  switch (data.type) {
    case 'message':
      return handleAppendMessages(vuexStore, data.text)
    default:
      return logger.info(`WS message.type.${data.type} is not implemented`)
  }
}

export const onOpen = (vuexStore: any): any => () => {
  window.websocketReadyPromise.resolve()

  vuexStore.commit('setWsReadiness', true)
  logger.info('Websocket is ready.')
}

export const onError = (vuexStore: any): any => () => {
  vuexStore.commit('setWsReadiness', false)
  logger.info('Websocket failed.')
}
